import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.features.list-approved-expense-items.ApprovedExpenseItemTable`

export default defineMessages({
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search approved expenses...',
  },
  sortReportNumberLabel: {
    id: `${scope}.sortReportNumberLabel`,
    defaultMessage: 'Report number',
  },
  sortApprovedDateLabel: {
    id: `${scope}.sortApprovedDateLabel`,
    defaultMessage: 'Approved date',
  },
  sortSubmittedDateLabel: {
    id: `${scope}.sortSubmittedDateLabel`,
    defaultMessage: 'Submitted date',
  },
  sortPrimaryCategoryLabel: {
    id: `${scope}.sortPrimaryCategoryLabel`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel}',
  },
  columnExpenseNumber: {
    id: `${scope}.columnExpenseNumber`,
    defaultMessage: 'Expense #',
  },
  columnPrimaryCategory: {
    id: `${scope}.columnPrimaryCategory`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel}',
  },
  columnSecondaryCategory: {
    id: `${scope}.columnSecondaryCategory`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  columnAccountCode: {
    id: `${scope}.columnAccountCode`,
    defaultMessage: 'Account code',
  },
  columnReceipt: {
    id: `${scope}.columnReceipt`,
    defaultMessage: 'Receipt',
  },
  columnType: {
    id: `${scope}.columnType`,
    defaultMessage: 'Type',
  },
  columnVendor: {
    id: `${scope}.columnVendor`,
    defaultMessage: 'Vendor',
  },
  columnRequester: {
    id: `${scope}.columnRequester`,
    defaultMessage: 'Requester',
  },
  columnSubmittedDate: {
    id: `${scope}.columnSubmittedDate`,
    defaultMessage: 'Submitted date',
  },
  columnApprovedDate: {
    id: `${scope}.columnApprovedDate`,
    defaultMessage: 'Approved date',
  },
  columnTotalAmount: {
    id: `${scope}.columnTotalAmount`,
    defaultMessage: 'Total amount',
  },
  columnComment: {
    id: `${scope}.columnComment`,
    defaultMessage: 'Comment',
  },
  columnExpensePurpose: {
    id: `${scope}.columnExpensePurpose`,
    defaultMessage: 'Expense purpose',
  },
  columnStatus: {
    id: `${scope}.columnStatus`,
    defaultMessage: 'Status',
  },
  statusApproved: {
    id: `${scope}.statusApproved`,
    defaultMessage: 'Approved',
  },
  statusPending: {
    id: `${scope}.statusPending`,
    defaultMessage: 'Pending',
  },
  statusDenied: {
    id: `${scope}.statusDenied`,
    defaultMessage: 'Denied',
  },
  statusDraft: {
    id: `${scope}.statusDraft`,
    defaultMessage: 'Draft',
  },
  receiptLinkAriaLabel: {
    id: `${scope}.receiptLinkAriaLabel`,
    defaultMessage: 'Receipt for {label}',
  },
  editAction: {
    id: `${scope}.editAction`,
    defaultMessage: 'Edit',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'There are no approved expenses',
  },
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Approved expense items',
  },
})
